import callApi from "../../utils/callApi";
import {
  getFeatureDetail,
  removeFeatureDetail,
} from "../reducers/featureDetail.reducers";

export const getFeatureDetailAction = (lstFeatureId, prodId, setLoading) => {
  return async (dispatch) => {
    const queryString = lstFeatureId?.map((id) => `&feature=${id}`).join("");

    try {
      setLoading(true);

      const res = await callApi(
        `product-info?product=${prodId}${queryString}`,
        "GET",
        null
      );

      await dispatch(getFeatureDetail(res.data.data));
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };
};

export const removeFeatureDetailAction = (prodId) => {
  return async (dispatch) => {
    await dispatch(removeFeatureDetail(prodId));
  };
};
